"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleErrors = exports.getBackendConfig = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireDefault(require("react"));
var _Translations = require("./Translations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// Handle errors in response
var handleErrors = function handleErrors(error) {
  if (error.response && error.response.status) {
    switch (error.response.status) {
      case 400:
        // handle the response with the format {error: 'message.'}
        var error_message = _lodash.default.get(error, 'response.data.error');
        if (error_message) {
          return error_message;
        }

        // get form_errors from response
        var errors = {};
        errors = _lodash.default.get(error, 'response.data.form_errors');
        errors = _objectSpread(_objectSpread({}, errors), _lodash.default.get(error, 'response.data.response.errors'));
        if (errors) {
          var errorsList = [];
          // Loop through errors
          _lodash.default.forOwn(errors, function (values, key) {
            if (typeof values[0] === 'string') {
              // If the value is a string, add key value pair to errorsList
              errorsList.push("".concat(key.toLocaleUpperCase(), ": ").concat(values[0], "."));
            } else {
              // If the value is not a string, loop through the values add key value pair to errorsList
              _lodash.default.forOwn(values[0], function (v, k) {
                errorsList.push("".concat(k.toLocaleUpperCase(), ": ").concat(v[0], "."));
              });
            }
          });
          return errorsList.join('\n');
        } else {
          return /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
            id: "Something went wrong",
            defaultMessage: "Something went wrong"
          });
        }
      case 401:
        // Handle unauthorized error
        return /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
          id: "Vous n'avez pas le droit d'effectuer cette op\xE9ration.",
          defaultMessage: "Vous n'avez pas le droit d'effectuer cette op\xE9ration."
        });
      default:
        return /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
          id: "Service inaccessible pour le moment.",
          defaultMessage: "Service inaccessible pour le moment."
        });
    }
  } else {
    // If error has no response return the message of error
    return error.message;
  }
};
exports.handleErrors = handleErrors;
var getBackendConfig = function getBackendConfig(key, defaultValue) {
  var _window = window,
    configs = _window.REACT_APP_CONFIGS_FROM_FLASK;
  if (configs && configs[key]) {
    return configs[key];
  } else if (defaultValue !== undefined) {
    return defaultValue;
  } else {
    var error = "Key ".concat(key, " is not passed from backend, and have no default value associated, check your settings");
    throw new Error(error);
  }
};
exports.getBackendConfig = getBackendConfig;